module.exports = __webpack_public_path__ + "static-appopensalud/img/openhealth_360_healthier_lives_white_MEX.917cd88.svg";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/openhealth_360_healthier_lives_white_MEX.svg
// module id = 1062
// module chunks = 120